$(function() {
  $('.theme__block').parent().css({
    'position': 'relative',
    // 'height': '100%',
  });
  $('.theme__block').parent().find(':not(".theme__block"):not(".theme__block__background"):not(".theme__block__stroke")').css({
    'z-index': '1',
    'position': 'relative',
  });

  $('.theme__tagline').parent().css({
    'position': 'relative',
  });
  $('.theme__tagline').parent().find(':not(".theme__tagline__stroke")').css({
    'z-index': '1',
  });

  $('.theme__stroke').parent().find(':not(".theme__stroke"):not(".theme__stroke__background"):not(".theme__block"):not(".theme__block__background")').css({
    'z-index': '1',
    'position': 'relative',
  });
  $('.theme__stroke').parent().css({
    'height': '100%',
    'position': 'relative',
  });
  $('.theme__stroke').parents('.module').css({
    'overflow': 'hidden',
  });
});
